import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Popover } from 'antd';
import { Classes } from 'jss';
import { MailListItemClassNames } from './MailListItem';
import UserAvatar from '../../../../components/UserAvatar';
import { Message } from '../../../../models/Message';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProjectId } from '../../../../models/Types';
import classNames from 'classnames';
import AssignMailInfoBox from './AssignMailInfoBox';
import { Contact } from '../../../../models/Contact';

interface AssignMailButtonProps {
  classes: Classes<MailListItemClassNames>;
  projectId: ProjectId;
  message: Message;
  loading?: boolean;
  getContactById: (contactId: string) => Contact | undefined;
}
export const AssignMailButton: React.FC<AssignMailButtonProps> = (props) => {
  //#region ------------------------------ Defaults
  const { classes, projectId, message, loading, getContactById } = props;
  const { t } = useTranslation();
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors

  const assignedToId = useMemo(
    () => message.customSingleValueExtendedProperties?.messageAssignmentId,
    [message]
  );

  const assignedToContact = useMemo(() => {
    return getContactById(assignedToId);
  }, [assignedToId, getContactById]);

  const [assignmentPopoverVisible, setAssignmentPopoverVisible] =
    useState(false);
  //#endregion

  //#region ------------------------------ Methods / Handlers
  //#endregion

  //#region ------------------------------ Effects
  //#endregion

  if (loading) {
    return (
      <div
        style={{
          minWidth: '1.5715em',
          minHeight: '1.5715em',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {!assignedToId ? (
          <FontAwesomeIcon
            icon={['fal', 'user-plus']}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setAssignmentPopoverVisible(!assignmentPopoverVisible);
            }}
            style={{ marginLeft: '3px' }}
            className={classNames(classes.assignmentIcon, {
              [classes.assignmentIconAssigned]: assignedToId,
            })}
          />
        ) : (
          <div
            style={{ display: 'block' }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setAssignmentPopoverVisible(!assignmentPopoverVisible);
            }}
            className={classNames(classes.assignmentIcon, {
              [classes.assignmentIconAssigned]: assignedToId,
            })}
          >
            <UserAvatar size={'tiny'} contact={assignedToContact} />
          </div>
        )}
      </div>
    );
  }

  return (
    <Popover
      placement="rightTop"
      trigger={'click'}
      visible={!loading && assignmentPopoverVisible}
      onVisibleChange={(visible) => {
        setAssignmentPopoverVisible(visible);
      }}
      destroyTooltipOnHide
      overlayClassName={classes.assignPopover}
      title={t('mail:messageDisplay.assignMessage')}
      content={
        <AssignMailInfoBox
          classes={classes}
          projectId={projectId}
          message={message}
          assignmentPopoverVisible={assignmentPopoverVisible}
          setAssignmentPopoverVisible={setAssignmentPopoverVisible}
          assignedToContact={assignedToContact}
          loading={loading}
        />
      }
    >
      <div
        style={{
          minWidth: '1.5715em',
          minHeight: '1.5715em',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          zIndex: 1,
        }}
      >
        {!assignedToId ? (
          <FontAwesomeIcon
            icon={['fal', 'user-plus']}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setAssignmentPopoverVisible(!assignmentPopoverVisible);
            }}
            style={{ marginLeft: '3px' }}
            className={classNames(classes.assignmentIcon, {
              [classes.assignmentIconAssigned]: assignedToId,
            })}
          />
        ) : (
          <div
            style={{ display: 'block' }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setAssignmentPopoverVisible(!assignmentPopoverVisible);
            }}
            className={classNames(classes.assignmentIcon, {
              [classes.assignmentIconAssigned]: assignedToId,
            })}
          >
            <UserAvatar size={'tiny'} contact={assignedToContact} />
          </div>
        )}
      </div>
    </Popover>
  );
};

export default AssignMailButton;
